import type { CSSProperties } from "react";

// Yellow-ochre dashed Beta banner shown above pricing cards and in
// onboarding step 2. Announces via role="status" aria-live="polite".

export default function BetaBanner({ style }: { style?: CSSProperties }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        marginTop: 18,
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        padding: "12px 14px",
        background: "rgba(168,122,58,0.14)",
        border: "1px dashed var(--ochre)",
        borderRadius: 10,
        ...style,
      }}
    >
      <div
        style={{
          padding: "3px 8px",
          borderRadius: 3,
          background: "var(--ochre)",
          color: "var(--paper-50)",
          fontFamily: "var(--f-ui)",
          fontSize: 9.5,
          fontWeight: 700,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          flexShrink: 0,
          marginTop: 1,
        }}
      >
        Beta
      </div>
      <div
        style={{
          fontFamily: "var(--f-body)",
          fontSize: 13.5,
          lineHeight: 1.4,
          color: "var(--ink-soft)",
        }}
      >
        Im Beta-Test ist aktuell nur das{" "}
        <strong style={{ color: "var(--ink)" }}>Basis-Paket</strong> buchbar.
        Premium und Exklusiv folgen ab 1. September 2026 — wir benachrichtigen Sie.
      </div>
    </div>
  );
}
